import { render, staticRenderFns } from "./RocistaReport.vue?vue&type=template&id=6586d372"
import script from "./RocistaReport.vue?vue&type=script&lang=js"
export * from "./RocistaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports